/* Suitality forms: fields by country, company lookup (French register), VAT format hints, address autocomplete. No dependencies. */
(function () {
  'use strict';

  /* Country rules. vat: example shown as placeholder; prefix: what a valid VAT number starts with; reg: label of the company register number. */
  var C = {
    'France': { iso: 'FR', prefix: 'FR', vat: 'FR12345678901', vatLabel: 'VAT number (TVA)', siret: true, lookup: true },
    'Austria': { iso: 'AT', prefix: 'ATU', vat: 'ATU12345678', reg: 'Company register number (FN)' },
    'Belgium': { iso: 'BE', prefix: 'BE', vat: 'BE0123456789', reg: 'Enterprise number (KBO/BCE)', regPh: '0123.456.789', vatFromReg: true },
    'Bulgaria': { iso: 'BG', prefix: 'BG', vat: 'BG123456789', reg: 'UIC (EIK)' },
    'Croatia': { iso: 'HR', prefix: 'HR', vat: 'HR12345678901', reg: 'OIB' },
    'Cyprus': { iso: 'CY', prefix: 'CY', vat: 'CY12345678X', reg: 'Company registration number' },
    'Czechia': { iso: 'CZ', prefix: 'CZ', vat: 'CZ12345678', reg: 'Company ID (IČO)' },
    'Denmark': { iso: 'DK', prefix: 'DK', vat: 'DK12345678', reg: 'CVR number' },
    'Estonia': { iso: 'EE', prefix: 'EE', vat: 'EE123456789', reg: 'Registry code' },
    'Finland': { iso: 'FI', prefix: 'FI', vat: 'FI12345678', reg: 'Business ID (Y-tunnus)' },
    'Germany': { iso: 'DE', prefix: 'DE', vat: 'DE123456789', vatLabel: 'VAT number (USt-IdNr.)', reg: 'Commercial register number (HRB)' },
    'Greece': { iso: 'GR', prefix: 'EL', vat: 'EL123456789', reg: 'GEMI number' },
    'Hungary': { iso: 'HU', prefix: 'HU', vat: 'HU12345678', reg: 'Company registration number' },
    'Ireland': { iso: 'IE', prefix: 'IE', vat: 'IE1234567X', reg: 'CRO number' },
    'Italy': { iso: 'IT', prefix: 'IT', vat: 'IT12345678901', vatLabel: 'VAT number (Partita IVA)' },
    'Latvia': { iso: 'LV', prefix: 'LV', vat: 'LV12345678901', reg: 'Registration number' },
    'Lithuania': { iso: 'LT', prefix: 'LT', vat: 'LT123456789', reg: 'Company code' },
    'Luxembourg': { iso: 'LU', prefix: 'LU', vat: 'LU12345678', reg: 'RCS number' },
    'Malta': { iso: 'MT', prefix: 'MT', vat: 'MT12345678', reg: 'Company registration number' },
    'Monaco': { iso: 'MC', prefix: 'FR', vat: 'FR12345678901', vatLabel: 'VAT number (starts with FR in Monaco)', reg: 'RCI number' },
    'Netherlands': { iso: 'NL', prefix: 'NL', vat: 'NL123456789B01', vatLabel: 'VAT number (btw-id)', reg: 'KvK number', regPh: '12345678' },
    'Norway': { iso: 'NO', prefix: 'NO', vat: 'NO123456789MVA', vatLabel: 'VAT number (MVA)', reg: 'Organisation number' },
    'Poland': { iso: 'PL', prefix: 'PL', vat: 'PL1234567890', vatLabel: 'VAT number (NIP)', reg: 'KRS number' },
    'Portugal': { iso: 'PT', prefix: 'PT', vat: 'PT123456789', vatLabel: 'VAT number (NIF)' },
    'Romania': { iso: 'RO', prefix: 'RO', vat: 'RO12345678', reg: 'Trade register number' },
    'Slovakia': { iso: 'SK', prefix: 'SK', vat: 'SK1234567890', reg: 'Company ID (IČO)' },
    'Slovenia': { iso: 'SI', prefix: 'SI', vat: 'SI12345678', reg: 'Registration number' },
    'Spain': { iso: 'ES', prefix: 'ES', vat: 'ESB12345678', vatLabel: 'VAT number (NIF/CIF)' },
    'Sweden': { iso: 'SE', prefix: 'SE', vat: 'SE123456789001', reg: 'Organisation number' },
    'Switzerland': { iso: 'CH', prefix: 'CHE', vat: 'CHE-123.456.789 MWST', vatLabel: 'UID / VAT number' },
    'United Kingdom': { iso: 'GB', prefix: 'GB', vat: 'GB123456789', vatLabel: 'VAT registration number', reg: 'Companies House number' }
  };
  var OTHER = { iso: '', prefix: '', vat: '', vatLabel: 'VAT or tax number', reg: 'Company registration number' };
  function rules(name) { return name ? (C[name] || OTHER) : null; }

  function frVat(siren) {
    var key = (12 + 3 * (Number(siren) % 97)) % 97;
    return 'FR' + (key < 10 ? '0' : '') + key + siren;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function wrap(el) { return el ? el.closest('.s-field') : null; }
  function labelOf(form, el) { return el && el.id ? form.querySelector('label[for="' + el.id + '"]') : null; }
  function setLabel(lab, text) {
    if (!lab) return;
    var n = lab.firstChild;
    if (n && n.nodeType === 3) n.textContent = text + ' '; else lab.insertBefore(document.createTextNode(text + ' '), lab.firstChild);
  }

  /* Combobox helper shared by company and address lookups */
  function combobox(input, fetcher, render, choose) {
    var list = document.getElementById(input.getAttribute('aria-controls'));
    if (!list) {
      list = document.createElement('ul');
      list.className = 's-suggest__list';
      list.id = input.id + '-list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      input.setAttribute('aria-controls', list.id);
      input.parentNode.appendChild(list);
      if (input.parentNode.classList) input.parentNode.classList.add('s-suggest');
    }
    var timer, items = [], active = -1, seq = 0;
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function show(rows, emptyText) {
      items = rows;
      list.innerHTML = '';
      if (!rows.length) {
        if (!emptyText) { close(); return; }
        var li0 = document.createElement('li');
        li0.className = 's-suggest__empty';
        li0.textContent = emptyText;
        list.appendChild(li0);
      }
      rows.forEach(function (r, i) {
        var li = document.createElement('li');
        li.id = input.id + '-opt-' + i;
        li.setAttribute('role', 'option');
        li.className = 's-suggest__item';
        li.innerHTML = render(r);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(r); close(); });
        list.appendChild(li);
      });
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      var my = ++seq;
      timer = setTimeout(function () {
        var p = fetcher(q);
        if (!p) { close(); return; }
        list.innerHTML = '<li class="s-suggest__empty">Searching…</li>';
        list.hidden = false;
        p.then(function (res) { if (my === seq) show(res.rows, res.empty); }).catch(close);
      }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      var opts = list.querySelectorAll('[role="option"]');
      if (!opts.length) { if (e.key === 'Escape') close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : opts.length - 1)) % opts.length;
        opts.forEach(function (o, i) { o.classList.toggle('is-active', i === active); o.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
        input.setAttribute('aria-activedescendant', opts[active].id);
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); choose(items[active]); close(); }
      else if (e.key === 'Escape') close();
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });
    return { close: close };
  }

  function initForm(form) {
    var country = form.querySelector('[data-company-country]');
    var company = form.querySelector('[data-company-lookup]');
    var vat = form.querySelector('[data-company-field="vat"]');
    var siret = form.querySelector('[data-company-field="siret"]');
    var reg = form.querySelector('[data-company-reg]');
    var note = form.querySelector('[data-company-note]');
    var vatHint = form.querySelector('[data-vat-hint]');
    if (vat && !vatHint) {
      vatHint = document.createElement('p');
      vatHint.className = 's-hint';
      vatHint.setAttribute('data-vat-hint', '');
      vatHint.setAttribute('aria-live', 'polite');
      vat.parentNode.appendChild(vatHint);
    }
    function field(name) { return form.querySelector('[data-company-field="' + name + '"]'); }
    function put(name, val, force) {
      var f = field(name);
      if (!f || !val) return;
      if (!force && f.value.trim() !== '') return;
      f.value = val;
      f.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function apply() {
      var r = rules(country ? country.value : 'France');
      var fr = !r || r.siret;
      if (siret) { var w = wrap(siret); if (w) w.hidden = !fr; if (!fr) siret.value = ''; }
      var sirenEl = field('siren'); if (sirenEl && !fr) sirenEl.value = '';
      if (reg) {
        var rw = wrap(reg);
        var hasReg = r && r.reg && !r.siret;
        if (rw) rw.hidden = !hasReg;
        if (hasReg) { setLabel(labelOf(form, reg), r.reg); reg.placeholder = r.regPh || ''; }
        else reg.value = '';
      }
      if (vat) {
        setLabel(labelOf(form, vat), (r && r.vatLabel) || 'VAT number');
        vat.placeholder = (r && r.vat) || 'FR12345678901';
      }
      if (note) {
        if (!r || r.lookup) note.textContent = 'Type at least 3 letters and pick your company: SIRET, VAT number and address fill in.';
        else note.textContent = 'Automatic search covers French companies. Enter your VAT number and registration number below.';
      }
      checkVat();
    }

    function checkVat() {
      if (!vat || !vatHint) return;
      var v = vat.value.replace(/[\s.\-]/g, '').toUpperCase();
      var r = rules(country ? country.value : '');
      vatHint.textContent = '';
      vat.removeAttribute('aria-invalid');
      if (!v) return;
      if (r && r.prefix && v.indexOf(r.prefix.replace(/[\s.\-]/g, '')) !== 0) {
        vatHint.textContent = 'VAT numbers in ' + country.value + ' start with ' + r.prefix + ', for example ' + r.vat + '.';
        return;
      }
      if (!/^[A-Z]{2,3}[0-9A-Z]{2,14}$/.test(v)) vatHint.textContent = 'Check the format, for example ' + ((r && r.vat) || 'FR12345678901') + '.';
    }

    if (vat) {
      vat.addEventListener('blur', function () {
        var r = rules(country ? country.value : '');
        var v = vat.value.trim().toUpperCase();
        if (r && r.prefix && /^[0-9]/.test(v)) vat.value = r.prefix + v;
        else vat.value = v;
        checkVat();
      });
      vat.addEventListener('input', checkVat);
    }
    if (reg) {
      reg.addEventListener('change', function () {
        var r = rules(country ? country.value : '');
        if (r && r.vatFromReg && vat && !vat.value.trim()) {
          var digits = reg.value.replace(/\D/g, '');
          if (digits.length === 10) { vat.value = r.prefix + digits; checkVat(); }
        }
      });
    }
    if (country) {
      country.addEventListener('change', apply);
      apply();
    }

    if (company) {
      combobox(company, function (q) {
        var r = rules(country ? country.value : '');
        if (r && !r.lookup) return null;
        if (q.length < 3) return null;
        return fetch('https://recherche-entreprises.api.gouv.fr/search?per_page=7&q=' + encodeURIComponent(q))
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var rows = (data.results || []).filter(function (x) { return x.siren; });
            return { rows: rows, empty: 'No French company found. Check the name, or fill in the fields below.' };
          });
      }, function (x) {
        var sg = x.siege || {};
        return '<span class="s-suggest__name">' + esc(x.nom_complet) + '</span><span class="s-suggest__meta">' +
          esc([sg.adresse, 'SIREN ' + x.siren].filter(Boolean).join(' · ')) + '</span>';
      }, function (x) {
        var sg = x.siege || {};
        company.value = x.nom_complet;
        if (country && !country.value) { country.value = 'France'; apply(); }
        put('siren', x.siren, true);
        put('siret', sg.siret, true);
        put('vat', frVat(x.siren), true);
        var street = [sg.numero_voie, sg.indice_repetition, sg.type_voie, sg.libelle_voie].filter(Boolean).join(' ');
        put('address', street || sg.adresse);
        put('postcode', sg.code_postal);
        put('city', sg.libelle_commune);
        checkVat();
        if (note) note.textContent = 'Filled in from the French company register. Check and correct if needed.';
      });
    }

    var addr = form.querySelector('[data-address-lookup]');
    if (addr) {
      combobox(addr, function (q) {
        if (q.length < 4) return null;
        var r = rules(country ? country.value : '');
        var iso = r ? r.iso : 'FR';
        if (!r || iso === 'FR') {
          return fetch('https://api-adresse.data.gouv.fr/search/?limit=6&q=' + encodeURIComponent(q))
            .then(function (res) { return res.json(); })
            .then(function (d) {
              return { rows: (d.features || []).map(function (f) { var p = f.properties; return { line: p.name, postcode: p.postcode, city: p.city, label: p.label }; }), empty: 'No address found. Keep typing or fill in the fields.' };
            });
        }
        return fetch('https://photon.komoot.io/api/?limit=8&lang=en&q=' + encodeURIComponent(q + (country && country.value ? ', ' + country.value : '')))
          .then(function (res) { return res.json(); })
          .then(function (d) {
            var rows = (d.features || []).map(function (f) { return f.properties; })
              .filter(function (p) { return !iso || p.countrycode === iso; })
              .map(function (p) {
                var line = [p.housenumber, p.street].filter(Boolean).join(' ') || p.name || '';
                if (p.countrycode === 'GB' || p.countrycode === 'IE') line = [p.housenumber, p.street].filter(Boolean).join(' ') || p.name || '';
                else if (p.housenumber && p.street) line = p.street + ' ' + p.housenumber;
                return { line: line, postcode: p.postcode || '', city: p.city || p.town || p.village || p.locality || '', label: [line, p.postcode, p.city || p.town || p.village].filter(Boolean).join(', ') };
              })
              .filter(function (x) { return x.line; })
              .slice(0, 6);
            return { rows: rows, empty: 'No address found. Keep typing or fill in the fields.' };
          });
      }, function (x) {
        return '<span class="s-suggest__name">' + esc(x.line) + '</span><span class="s-suggest__meta">' + esc([x.postcode, x.city].filter(Boolean).join(' ')) + '</span>';
      }, function (x) {
        addr.value = x.line;
        put('postcode', x.postcode, true);
        put('city', x.city, true);
      });
    }
  }

  function init() {
    var forms = [];
    document.querySelectorAll('[data-company-country], [data-company-lookup], [data-address-lookup]').forEach(function (el) {
      if (el.form && forms.indexOf(el.form) === -1) forms.push(el.form);
    });
    forms.forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
